import { createElement, Fragment } from 'react';
import { Button } from '../Button/Button.js';
import { useGaudiLocalization } from '../Provider/Provider.js';

var createPageRange = function createPageRange(pageCount, pageNumber) {
  var lowerLimit = Math.min(pageNumber, pageCount);
  var upperLimit = Math.min(pageNumber, pageCount);

  for (var b = 1; b < 5 && b < pageCount;) {
    if (lowerLimit > 1) {
      lowerLimit--;
      b++;
    }

    if (b < 5 && upperLimit < pageCount) {
      upperLimit++;
      b++;
    }
  }

  var range = [];

  for (var i = lowerLimit; i <= upperLimit; i++) {
    range.push(i);
  }

  return range;
};

var PageNumbers = function PageNumbers(_ref) {
  var _ref$currentPageIndex = _ref.currentPageIndex,
      currentPageIndex = _ref$currentPageIndex === void 0 ? 0 : _ref$currentPageIndex,
      handleClick = _ref.onClick,
      pageCount = _ref.pageCount;
  var range = createPageRange(pageCount, currentPageIndex + 1);

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  return createElement(Fragment, null, range.map(function (pageNumber) {
    return createElement(Button, {
      appearance: pageNumber === currentPageIndex + 1 ? 'primary' : 'default',
      "aria-current": pageNumber === currentPageIndex + 1 ? 'page' : undefined,
      key: pageNumber,
      onClick: function onClick() {
        return handleClick(pageNumber - 1);
      },
      "aria-label": texts.pagination.actions.pageX.replace('[X]', String(pageNumber)),
      tooltip: texts.pagination.actions.pageX.replace('[X]', String(pageNumber))
    }, pageNumber);
  }));
};

export { PageNumbers };
//# sourceMappingURL=PageNumbers.js.map
